import { RESET_STATE } from "./actions.type";
import { SET_IS_LOADING, SET_TIMEOUT_ERROR, SET_TOAST,STATE_RESET } from "./mutations.type";


const initialState = () => {
  return {
    isLoading: false,
    toastmessage: null,
    showtoast: false,
    timeouterror:{
      title:null,
      message:null,
      isOpen: false,
    }
  }
};

export const state = initialState();

const actions = {

  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {
  [SET_TOAST](state,status){
    state.toastmessage = status.message
    state.showtoast = status.showtoast
  },
  [SET_TIMEOUT_ERROR](state,data){
    state.timeouterror.title = data.title
    state.timeouterror.message = data.message
    state.timeouterror.isOpen = data.isOpen
  },
  [SET_IS_LOADING](state, status) {
    state.isLoading= status
  },
  [STATE_RESET]() {
    Object.assign(state,initialState())
  }

}

const getters = {
  isLoading(state) {
    return state.isLoading;
  },
  timeouterror(state){
    return state.timeouterror;
  }

}

export default {
    state,
    getters,
    actions,
    mutations
};